export default "__VITE_ASSET__BFnwlt_H__"